export default __webpack_public_path__ + "static/media/hu.e404d718.svg";